document.addEventListener('DOMContentLoaded', function () {
    var hideButtons = document.querySelectorAll('.hide-notices');
    hideButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var popup = btn.closest('.notices-popup');
            if (popup) {
                popup.classList.add('inactive');
            }
        });
    });

    var openModalButtons = document.querySelectorAll('.notices-popup .open-modal');
    openModalButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            var modals = document.querySelectorAll('.notices-modal');
            modals.forEach(function (m) { m.classList.add('active'); });
            document.body.classList.add('notices-modal-open');

            e.preventDefault();
        });
    });
});


